/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Tabs, TabPanel } from 'sarsaparilla';

import type { Tab } from './SharedVenuePage.types';

export interface TabItemsProps {
    tabs?: Tab[];
    activeTabIndex?: number;
    onActiveTabIndexChange?: (index: number) => void;
}

export function TabItems({
    tabs,
    activeTabIndex,
    onActiveTabIndexChange,
}: TabItemsProps) {
    if (!tabs || !tabs.length) return null;

    return (
        <Tabs
            stretchTabsToFit
            appearance="underline"
            activeIndex={activeTabIndex}
            onChange={onActiveTabIndexChange}
        >
            {tabs.map((tab) => (
                <TabPanel key={tab.label} label={tab.label}>
                    <div className="rec-full-content-wrap">{tab.content}</div>
                </TabPanel>
            ))}
        </Tabs>
    );
}
